module.exports = __webpack_public_path__ + "static/cause-1-3-d32c5c5382abe499baac3302ecea72da.jpg";